module.exports = __webpack_public_path__ + "img/client-happy-with-smart-wifi.8d8cb0b8.jpg";